// extracted by mini-css-extract-plugin
module.exports = {"text":"CustomSecondaryListItemText_text__VFIdJ","textContainer":"CustomSecondaryListItemText_textContainer__mLD2P"};